import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { checkIsMergeAndAcquisitionLayout } from "@frontend/common";
import { DEAL_TYPE_KEYS } from "@frontend/common/src/business/FillInTable/constants/dealTypeKeys.constants";

import { useEntryDataState } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

type CurrentDealFilingType = {
  currentDealFilingTypeList: string[];
  isMergeAndAcquisition: boolean;
};

const CheckCurrentDealFilingTypeContext = createContext<CurrentDealFilingType>({
  currentDealFilingTypeList: [],
  isMergeAndAcquisition: false,
});

export const CheckCurrentDealFilingTypeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const draftArticleId = getPressIdFromURL();
  const [entryData] = useEntryDataState(draftArticleId);
  const [currentChoiceDealFilingType, setCurrentChoiceDealFilingType] =
    useState<string[]>([DEAL_TYPE_KEYS.licenseAgreement]);
  const currentDealType = useMemo(
    () =>
      entryData?.["Deal Filing"]?.["Deal Type & Status"]?.[
        "Deal Type"
      ].value.map((dealTypeItem) => dealTypeItem.text) || [],
    [entryData],
  );

  useEffect(() => {
    const isMAndAType = checkIsMergeAndAcquisitionLayout(currentDealType);

    if (isMAndAType)
      return setCurrentChoiceDealFilingType([
        DEAL_TYPE_KEYS.mergeAndAcquisition,
      ]);

    setCurrentChoiceDealFilingType(
      currentDealType.map((dealType) => dealType.toLocaleLowerCase()),
    );
  }, [currentDealType]);

  const returnCurrentDealFilingType = useMemo(() => {
    return {
      currentDealFilingTypeList: currentChoiceDealFilingType,
      isMergeAndAcquisition: checkIsMergeAndAcquisitionLayout(
        currentChoiceDealFilingType,
      ),
    };
  }, [currentChoiceDealFilingType]);

  return (
    <CheckCurrentDealFilingTypeContext.Provider
      value={returnCurrentDealFilingType}
    >
      {children}
    </CheckCurrentDealFilingTypeContext.Provider>
  );
};

export const useCurrentDealFilingTypeValue = () => {
  const { currentDealFilingTypeList, isMergeAndAcquisition } = useContext(
    CheckCurrentDealFilingTypeContext,
  );

  return {
    currentDealFilingTypeList,
    isMergeAndAcquisition,
  };
};
